export const money = value => `$${Number(value || 0).toFixed(5)}`;
export const testKey = value => String(value).toLowerCase().replace(/[^a-z0-9]+/g, "-");
export const colors = ["#A6192E", "#267356", "#2563EB", "#AD7100", "#605181", "#6B6B6B"];